
export default {
    data: () => ({
        imageUploadTypeEnums: {
            firstVisit: 'hr_co.farm.firstVisit',
            technicalVisitView: 'hr_co.field.technicalVisitView',
        }
    })
}
